<template>
  <div class="container">
    <header>
      <h2>BedBoard App</h2>
    </header>
    <div>
      Welcome to your BedBoard App. Use the features in this app to easily view and manage your clients' stays at the locations you need to monitor. Customize the layout settings and the list of units you want to view in your user preferences.
    </div>

    <div v-if="isOccupancyReportViewable" style="margin-top: 30px">
      <v-flex class="text-xs-center" v-if="isBusy">
        <busy-animation></busy-animation>
      </v-flex>
      <div v-else-if="occupancyReportPayload">
        <v-layout row>
          <v-flex>
            <div class="occupancyReportTitle">{{occupancyReportPayload.reportTitle}}</div>
          </v-flex>
          <v-flex>
            <v-btn style="float: right; margin-left:10px;" v-on:click="runReport()">Run Report</v-btn>
          </v-flex>
        </v-layout>
        <span style="float: right;" v-if="occupancyReportPayload.lastRunDate" class="occupancyLastRun">Last run: {{occupancyReportPayload.lastRunDate| moment('M/D/YYYY h:mm a')}}</span>

        <table class="occupancyReportTable" cell-spacing="0" cellpadding="0">
          <tbody>
            <tr v-for="(row, index) in occupancyReportPayload.rows" :key="index">
              <td class="occupancyReportRowTitle"><span v-html="getIndent(row.level)"></span> {{ row.title }}</td>
              <td v-if="row.showValues" class="occupancyReportRowTitle">
                <table>
                  <tbody>
                    <tr>
                      <td class="occupancyReportRowLabel">Maximum</td>
                      <td class="occupancyReportRowValue">{{ row.maximum }}</td>
                    </tr>
                    <tr>
                      <td class="occupancyReportRowLabel">Occupied</td>
                      <td class="occupancyReportRowValue">{{ row.occupied }} ({{ row.occupiedPercentage }})</td>
                    </tr>
                    <tr>
                      <td class="occupancyReportRowLabel">Reserved</td>
                      <td class="occupancyReportRowValue">{{ row.reserved }}</td>
                    </tr>
                    <tr>
                      <td class="occupancyReportRowLabel">Available</td>
                      <td class="occupancyReportRowValue">{{ row.available }} ({{ row.availablePercentage }})</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td v-else class="occupancyReportRowTitle"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        No occupancy report data
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.occupancyReportTable {
  width: 100%;
  border: 1px solid darkgray;
}
.occupancyReportRowTitle {
  width: 70%;
  font-family: "Montserrat";
  font-size: 16px;
}
.occupancyReportRowLabel {
  font-family: "Montserrat";
  font-size: 14px;
  font-style: italic;
  border: none;
}
.occupancyReportRowValue {
  font-size: 14px;
  font-family: "Montserrat";
  padding-left: 10px;
}

.occupancyReportTitle {
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
}
</style>

<script>
import moment from 'moment';
import appSettings from '../appSettings';
import BusyAnimation from './BusyAnimation.vue';

export default {
  data() {
    return {
      isBusy: false
    };
  },

  created() {
    this.$eventbus.$on('GenerateOccupancyReport', async () => {
      if (this.$store.getters.isOccupancyReportViewable) {
        this.isBusy = true;
        this.$store
          .dispatch('generateOccupancyReportPayload')
          .catch((err) => {
            this.$log.error(`[${moment().format(appSettings.logDateFormat)}] Home.created: '${err.message}' `);
            this.$eventbus.$emit('showToast', { header: 'Error', message: 'Unable to generate report.', type: 'error' });
          })
          .finally(() => {
            this.isBusy = false;
          });
      }
    });

    if (this.$store.getters.isOccupancyReportViewable) {
      this.$eventbus.$emit('GenerateOccupancyReport');
    }
  },
  mounted() {
    // NOTE: Remove selectedUnit whenever navigated to home.
    this.$store.commit('setSelectedUnit', null);
  },
  components: {
    'busy-animation': BusyAnimation
  },
  computed: {
    occupancyReportPayload() {
      return this.$store.getters.occupancyReportPayload;
    },
    isOccupancyReportViewable() {
      return this.$store.getters.isOccupancyReportViewable;
    }
  },
  methods: {
    getIndent(level) {
      return '&emsp;'.repeat(level);
    },
    runReport() {
      this.$eventbus.$emit('GenerateOccupancyReport');
    }
  }
};
</script>
